import { FormattedMessage } from "react-intl";
function Footer() {
  return (
    <footer className="flex w-full flex-col items-center justify-center py-8">
      <div className="flex gap-4 text-sm">
        <a
          className="text-primary-blue hover:underline"
          target="_blank"
          href="https://www.newsguardtech.com/terms-of-service/"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="template.tos" defaultMessage="Terms of Service" />
        </a>
        <a
          className="text-primary-blue hover:underline"
          target="_blank"
          href="https://www.newsguardtech.com/privacy-policy/"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="template.privacy_policy" defaultMessage="Privacy Policy" />
        </a>
        <a
          className="text-primary-blue cursor-pointer hover:underline"
          onClick={() => {
            if (window.ketch) {
              window.ketch("showExperience");
            } else {
              console.log("Privacy Settings clicked");
            }
          }}
        >
          <FormattedMessage id="auth.privacySettings" defaultMessage="Privacy Settings" />
        </a>
      </div>
      <div className="mt-3 text-sm">
        <FormattedMessage
          id="auth.copyright"
          defaultMessage="© {year} NewsGuard Technologies, Inc."
          values={{ year: new Date().getFullYear() }}
        />
      </div>
      <div className="mt-3 text-sm uppercase">
        <FormattedMessage
          id="auth.confidential"
          defaultMessage="Confidential and Proprietary"
        />
      </div>
    </footer>
  );
}

export default Footer;
